import React from 'react';
import Navbar from '../../components/navbar';
import FormularioEditarCapi from '../../components2/formularioEditarCapi';

function EditarCapi () {
    return (
        <FormularioEditarCapi />
    )
}

export default EditarCapi;